const loadingBar = require('./ui.loadingBar')
const app = require('./app.js')
const { timeAgo } = require('./timeAgo.js')

class ui_device {
    dataType = 'device'
    constructor(device) {
        this.device_id = device.device_id
        loadingBar.show()
        this.currentTabIndex = 0 // Initialize to the index of the first tab
        this.tabContainer = document.querySelector('#device-profile .tab-container')
        this.container = document.querySelector('#device-profile')
        const tabs = document.querySelectorAll('#device-profile .nav-cover > button')
        const self = this
        tabs.forEach((tab, index) => {
            tab.onclick = function () {
                self.changeTab(index)
            }
        })

        setTimeout(function () {
            self.changeTab(0)
        }, 1)
        document.querySelector('#device-profile .back-button').onclick = function () {
            if (history.state.page && history.state.page > 1) {
                history.back()
            }
            self.close()
            if (document.querySelector('.payment-banner')) {
                document.querySelector('.payment-banner').style.display = 'none'
                document.getElementById('location-holder').querySelector('.payment-banner').style.display = 'none'
            }
        }

        this.fill(device)
        this.show()

        window.addEventListener('resize', this.omWindowResize.bind(this))

        this.isSubActive = device.subState === 'pending' || device.subState === 'approved' || device.subState === 'canceled'
        let locationTab = document.getElementById('location')
        let paymentPopUpLocBlock = document.createElement('div')
        let paymentPopUpCastBlock = document.createElement('div')
        if (!this.isSubActive) {
            paymentPopUpCastBlock.classList.add('payment-banner')
            paymentPopUpLocBlock.classList.add('payment-banner')

            paymentPopUpCastBlock.innerHTML = `
                <div class="payment-banner__text">Subscribe to view all screenshots</div>
                <div class="payment-banner__btn payment-banner__btn--cast">Subscribe</div>
            `
            paymentPopUpLocBlock.innerHTML = `
                <div class="payment-banner__text">Subscribe to view all locations</div>
                <div class="payment-banner__btn payment-banner__btn--loc">Subscribe</div>
            `
            if (!document.querySelector('.payment-banner')) {
                document.querySelector('.cast-holder').appendChild(paymentPopUpCastBlock)
                document.getElementById('location-holder').append(paymentPopUpLocBlock)
            }

            locationTab.classList.add('sb-bl')
            document.querySelector('.payment-banner').style.display = 'block'
            document.getElementById('location-holder').querySelector('.payment-banner').style.display = 'block'
            document.querySelector('.payment-banner__btn--cast').addEventListener('click', () => {
                if (!document.querySelector('.payment-plans')) {
                    this.showPaymentsPlan()
                }
            })
            document.querySelector('.payment-banner__btn--loc').addEventListener('click', () => {
                if (!document.querySelector('.payment-plans')) {
                    this.showPaymentsPlan()
                }
            })
        }
    }

    showPaymentsPlan() {
        const container = document.getElementById('device-profile')
        const containerPlans = document.createElement('div')
        const containerBackground = document.createElement('div')
        containerPlans.setAttribute('class', 'payment-plans')
        containerBackground.setAttribute('class', 'payment-background')
        containerPlans.innerHTML = ui.pricings.pricingHtml
        container.appendChild(containerPlans)
        container.appendChild(containerBackground)

        var planList = document.querySelectorAll('.payment-plans__item')
        let selectedPlan
        planList.forEach((e) => {
            e.addEventListener('click', () => {
                planList.forEach((e) => {
                    e.classList.remove('payment-plans__item--selected')
                })
                e.classList.add('payment-plans__item--selected')
                selectedPlan = e.dataset.plan
            })
        })
        document.querySelector('.payment__block__button').addEventListener('click', () => {
            this.creatPaymentUrl(selectedPlan, 'paypal')
        })
        document.querySelector('.payment__block__button--credit').addEventListener('click', () => {
            this.creatPaymentUrl(selectedPlan, 'credit')
        })
        document.querySelector('.payment__block__close').addEventListener('click', () => {
            containerPlans.classList.add('slideOut')
            containerBackground.remove()
            setTimeout(() => {
                document.querySelector('.payment-plans').remove()
            }, 800)
        })
    }
    creatPaymentUrl(plan, btnClicked) {
        this.GetPaymentToken()
            .then((put_token) => {
                if (!plan) {
                    plan = document.querySelector('.payment-plans__item--selected').dataset.plan
                }
                let pprov = 'paypal'
                if (btnClicked.includes('credit')) {
                    pprov = 'stripe'
                }
                if (typeof gtag === 'function') {
                    console.log('Gtag for pay ', 'to_pay_' + pprov, {
                        amount: plan
                            .replace(/t3_|t2_|mdm_/, '')
                            .replace(/[a-z]_/, '')
                            .replace('_', '.'),
                    })
                    //gtag('event', 'to_pay_' + btnClicked + '_' + plan.replace(/t3_|t2_|mdm_/, ''))
                    gtag('event', 'to_pay_' + pprov, {
                        amount: plan
                            .replace(/t3_|t2_|mdm_/, '')
                            .replace(/[a-z]_/, '')
                            .replace('_', '.'),
                    })
                } else {
                    console.log('No Gtag')
                }
                if (put_token && btnClicked === 'paypal') {
                    window.location.href = `https://pay.livescreenapp.com/plugin/firebase_login/?at=${encodeURIComponent(put_token)}&did=${encodeURIComponent(this.device_id)}&sku=${encodeURIComponent(plan)}&returnUrl=${encodeURIComponent(location.href)}`
                } else if (put_token && btnClicked === 'credit') {
                    window.location.href = `https://pay.livescreenapp.com/plugin/firebase_login/?at=${encodeURIComponent(put_token)}&did=${encodeURIComponent(this.device_id)}&pmgw=stripe&sku=${encodeURIComponent(plan)}&returnUrl=${encodeURIComponent(location.href)}`
                }
            })
            .catch((e) => {
                console.log(e)
            })
    }

    async GetPaymentToken() {
        let pt = this.parsePutToken()
        console.log('payment-token before:', pt)
        if (pt) {
            return pt
        }
        const resp = await fetch(`https://caapi.livescreenapp.com/api/get-payment-token`, {
            method: 'GET',
            credentials: 'include',
            headers: {
                Accept: 'application/json',
            },
        }).then((r) => {
            if (!(r.ok || r.status === 200)) {
                throw new Error('handle no put token')
            }
        })
        pt = this.parsePutToken()
        console.log('payment-token:', pt)
        return pt
    }
    parsePutToken() {
        return document.cookie
            .split('; ')
            .find((row) => row.startsWith('put_token='))
            ?.split('=')[1]
    }

    fill(device) {
        let els = document.querySelectorAll('#device-profile [data-device]')
        for (let el of els) {
            let key = el.dataset.device
            if (key === 'lastSeen') {
                el.innerHTML = timeAgo(device[key])
                continue
            }
            el.innerHTML = device[key]
        }
    }

    changeTab(newTabIndex, tab) {
        const containerWidth = this.tabContainer.offsetWidth
        const singleTabWidth = document.querySelector('#device-profile .tab-container > div').offsetWidth
        const translateAmount = -singleTabWidth * newTabIndex
        const translateAmountBack = singleTabWidth * newTabIndex
        if (newTabIndex === 1) {
            document.getElementById('location-holder').style.display = 'block'
            document.getElementById('cast').style.display = 'none'
            document.body.style.overflowY = 'hidden'
            document.getElementById('location-holder').style.minWidth = '100vw'
            document.getElementById('location-holder').style.transform = `translateX(${translateAmountBack}px)`
        } else if (newTabIndex === 0) {
            document.body.style.overflowY = 'hidden'
            document.getElementById('location-holder').style.display = 'none'
            document.getElementById('cast').style.display = 'flex'
            document.getElementById('cast').style.overflowY = 'auto'
        }
        // Update the transform style to slide the tab container
        this.tabContainer.style.transform = `translateX(${translateAmount}px)`

        // Update the active button
        document.getElementById('btn-' + this.currentTabIndex).classList.remove('active')
        document.getElementById('btn-' + newTabIndex).classList.add('active')

        // Update the active indicator
        // if (document.)
        const indicator = document.getElementById('active-indicator')
        const btn = document.getElementById('btn-' + newTabIndex)
        // indicator.style.width = btn.offsetWidth + 'px';
        // indicator.style.left = btn.offsetLeft + 'px';
        if (btn.id === 'btn-0') {
            indicator.style.left = '0'
        } else {
            indicator.style.left = '180px'
        }

        // Update current tab index
        this.currentTabIndex = newTabIndex
    }

    show() {
        loadingBar.hide()
        this.container.classList.add('show')
        setTimeout(() => {
            this.container.classList.remove('fadeInUp')
        }, 500)
        document.body.style.overflowY = 'hidden'
        document.querySelector('.body-content').style.overflowY = 'hidden'
    }

    close() {
        this.container.classList.add('fadeOutDown')
        setTimeout(() => {
            const tabs = document.querySelectorAll('#device-profile .tab-content')
            tabs.forEach((tab) => {
                tab.scrollTop = 0
                tab.innerHTML = ''
            })
            this.container.classList.remove('show')
            this.container.classList.remove('fadeOutDown')
            this.container.classList.add('fadeInUp')
            // document.body.style.overflow = ''
            document.body.style.overflowY = ''
            document.querySelector('.body-content').style.overflowY = ''
        }, 500)

        window.removeEventListener('resize', this.omWindowResize.bind(this))
    }

    omWindowResize() {
        this.changeTab(this.currentTabIndex)
    }

    update() {
        app.data.get({ type: 'device', identifier: this.device_id }, (data) => {
            this.fill(data)
        })
    }
}

module.exports = ui_device
